/**
 * faq-accordion-single-open.js
 *
 * The theme's own <details is="collapsible-row"> element already animates
 * its open/close height smoothly via Motion.animate (see theme.js,
 * CollapsibleRowDetails.transition — duration 0.3s). What it does NOT do
 * on its own is close sibling rows when a new one opens, so multiple FAQ
 * answers can stay open at once, which is what reads as "not smooth".
 *
 * This script adds that behavior without touching the shared theme.js
 * bundle (which also powers collapsible rows elsewhere in the theme —
 * menus, filters, etc.): whenever a row is opened, every other open row
 * in the same FAQ container is closed by setting `row.open = false` —
 * which routes through the theme's own custom-element setter and reuses
 * its existing smooth Motion.animate close transition, so the animation
 * stays perfectly consistent with the rest of the site.
 */
(function () {
  if (window.__faqAccordionSingleOpenInit) return;
  window.__faqAccordionSingleOpenInit = true;

  document.addEventListener('click', function (event) {
    var summary = event.target.closest('.collapsible-row__summary');
    if (!summary) return;

    var details = summary.closest('details.collapsible-row');
    if (!details) return;

    // The theme's own click handler is bound directly on the summary
    // element during connectedCallback (i.e. registered before this
    // delegated document-level listener runs), so by the time this
    // bubbles up to `document`, `details.open` already reflects the
    // new state.
    if (!details.open) return; // only react when this row just opened

    var scope = details.closest('.faq-container') || details.closest('.accordion-block') || details.parentElement;
    if (!scope) return;

    scope.querySelectorAll('details.collapsible-row').forEach(function (row) {
      if (row !== details && row.open) {
        row.open = false; // reuses the theme's own smooth close animation
      }
    });
  });
})();
